import request from '@/utils/request'

// 调查问卷提交
export function synopsistop6(query) {
  return request({
    url: 'api/index/synopsistop6',
    method: 'get',
    params: query
  })
}

// 分享
export function share(query) {
  return request({
    url: 'api/weixin/getJsApi',
    method: 'post',
    params: query
  })
}

// 通过key查询系统参数
export function getConfByKey(query) {
  return request({
    url: '/api/config/getConfByKey',
    method: 'get',
    params: query
  })
}

// 获取导航栏
export function menuList(query) {
  return request({
    url: '/api/menuNavigation/menuList',
    method: 'get',
    params: query
  })
}
// 提交留言
export function AddOnlineMessage(data) {
  return request({
    url: '/api/message/AddOnlineMessage',
    method: 'post',
    data: data
  })
}

// 修改阅读量
export function updateReadingVolume(data) {
  return request({
    url: '/api/websiteArticle/updateReadingVolume',
    method: 'PUT',
    params: data
  })
}


// 增加访问量
export function visit(data) {
  return request({
    url: '/api/visit',
    method: 'post',
    data: data
  })
}
// 手机端公司新闻/行业动态搜索
export function getNewsListBySearchName (query) {
  return request({
    url: '/api/websiteArticle/getNewsListBySearchName',
    method: 'get',
    params: query
  })
}

// 手机端产品搜索
export function getProductSearchName (query) {
  return request({
    url: '/api/product/getProductSearchName',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js